import React from 'react';
import styled from 'styled-components';
import { ModalShell } from '../ui/shell';
import { Btn, Field, Input, FormGrid } from '../ui/primitives';
import { ButtonSpinnerSlot } from '../ui/ButtonSpinner';
import { LabelWithHelp } from '../ui/FieldHelp';
import { SYSTEM_SETTINGS_FIELD_HELP as HELP } from '../ui/settingsFieldHelp';

const FormRoot = styled.div`
  display: flex;
  flex-direction: column;
`;

const GridField = styled(Field)`
  margin-bottom: 0;
  min-width: 0;
`;

const TwoColGrid = styled(FormGrid)`
  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

/**
 * Role settings modal — update split-payment percentage for admin role.
 * Presentation uses portal ModalShell + primitives; submit logic stays in parent.
 */
const FormDialog = ({ open, handleClose, data, onChange, handleFormSubmit, loading }) => {
  const handleSubmit = async () => {
    try {
      await handleFormSubmit();
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  if (!open) return null;

  return (
    <ModalShell
      title={data ? 'Update Role' : 'Add Role'}
      onClose={handleClose}
      max="480px"
      foot={(
        <>
          <Btn type="button" $variant="ghost" onClick={handleClose} disabled={loading}>
            Cancel
          </Btn>
          <Btn type="button" $variant="subtle" onClick={handleSubmit} disabled={loading}>
            {loading ? (
              <ButtonSpinnerSlot size={16} />
            ) : (
              data.id ? 'Update' : 'Submit'
            )}
          </Btn>
        </>
      )}
    >
      <FormRoot>
        <TwoColGrid>
          <GridField>
            <label htmlFor="role"><LabelWithHelp help={HELP.role}>Role</LabelWithHelp></label>
            <Input
              autoFocus
              id="role"
              type="text"
              value={data.role}
              onChange={onChange}
              disabled={data ? true : false}
            />
          </GridField>
          <GridField>
            <label htmlFor="percentage"><LabelWithHelp help={HELP.percentage}>Percentage</LabelWithHelp></label>
            <Input
              id="percentage"
              type="number"
              value={data.percentage}
              onChange={onChange}
            />
          </GridField>
        </TwoColGrid>
      </FormRoot>
    </ModalShell>
  );
};

export default FormDialog;
